module.exports = __webpack_public_path__ + "static/media/casa-logo.0c804875.svg";